import { lazy, Suspense, useEffect, useState } from "react";
import { Search, Sparkles } from "lucide-react";
import { useNLPChat } from "./NLPChatContext";

// Lazy: NLPChatModal pulls in recharts (via NLPChart) and this bar is on
// every authenticated page. Loaded when the chat first opens (`everOpened`),
// then kept mounted so its state survives closing.
const NLPChatModal = lazy(() =>
  import("./NLPChatModal").then((m) => ({ default: m.NLPChatModal }))
);

export function NLPSearchBar() {
  const { isOpen, openChat, closeChat } = useNLPChat();
  const [everOpened, setEverOpened] = useState(false);
  useEffect(() => {
    if (isOpen) setEverOpened(true);
  }, [isOpen]);

  // ⌘K belongs to the COMMAND PALETTE (Sidebar mounts both shortcuts); the
  // chat answers to ⌘J. Two listeners on ⌘K would have opened both.
  return (
    <>
      {/* Desktop: full search bar */}
      <div
        role="button"
        tabIndex={0}
        onClick={() => openChat()}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") openChat();
        }}
        className="hidden md:flex items-center gap-2 w-full max-w-lg h-10 bg-white/90 border border-slate-200 rounded-xl text-sm shadow-sm hover:border-brand-lagune-300 hover:shadow-md transition-all cursor-text group"
      >
        <Search className="ml-3.5 w-4 h-4 text-slate-400 group-hover:text-brand-lagune-600 transition-colors flex-shrink-0" />
        <span className="flex-1 text-slate-500 truncate">
          Poser une question à l'assistant…
        </span>
        <div className="flex items-center gap-2 mr-3">
          {/* Both shortcuts are advertised HERE, on the one surface that is
              always visible: a keyboard feature nobody is told about does
              not exist for the user who has not been told. */}
          <span className="hidden xl:inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-medium text-slate-600 bg-slate-100 border border-slate-200 rounded">
            <span className="text-xs">⌘</span>K
            <span>rechercher</span>
          </span>
          <span className="hidden lg:inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-medium text-slate-600 bg-slate-100 border border-slate-200 rounded">
            <span className="text-xs">⌘</span>J
          </span>
          <Sparkles className="w-4 h-4 text-brand-lagune-600" />
        </div>
      </div>

      {/* Mobile: icon button */}
      <button
        onClick={() => openChat()}
        className="md:hidden p-2 text-slate-500 hover:text-brand-lagune-600 hover:bg-brand-lagune-50 rounded-lg transition-colors"
      >
        <Search className="w-5 h-5" />
      </button>

      {everOpened && (
        <Suspense fallback={null}>
          <NLPChatModal open={isOpen} onClose={closeChat} />
        </Suspense>
      )}
    </>
  );
}
